// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xx_a bib_a bib_x","StrollerDetailRating__muted":"xx_b bib_fo"};